import { defineMessages } from 'react-intl';

export const messages: {
	settings: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	settings: {
		defaultMessage: 'Settings',
		description:
			'Label for the top navigation button that opens the settings menu. Read out by screen readers and shown in the button tooltip.',
		id: 'global-top-navigation.settings.settings',
	},
});
